import React, { Component } from 'react';
import { IDocumentsRowProps } from './IDocuments';
import IV from '../InputValidation/InputValidation';

import * as styles from './DocumentsStyles.module.scss';
import * as appStyles from '../../AppStyle.module.scss';

export default class DocumentRow extends Component<IDocumentsRowProps> {

  state = {
    editing: false,
  };

  deleteDocument = () => {
    this.props.delete(this.props.document.id);
  }

  showRow() {
    const { document } = this.props;

    return (
      <a
        className={styles.documents_doc}
        href={document.file}
        key={document.id}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="fa fa-file-text-o" />
        {document.file_name}
      </a>
    );
  }

  showRowEdit() {
    const { document } = this.props;
    const editClass = this.state.editing ?
      [appStyles.editButton, appStyles.editButtonActive].join(' ') :
      appStyles.editButton;

    return (
      <div className={styles.documents_doc}>
        <a href={document.file} target="_blank" className={styles.valueHolder} rel="noopener noreferrer">
          <span className="fa fa-file-text-o" />
          <IV type="noEmpty" dispatch={this.props.dispatch} value={document.file_name}>
            <p>{document.file_name}</p>
          </IV>
        </a>
        <div className={styles.buttons}>
          <button className={appStyles.cancelButton} onClick={this.deleteDocument} />
        </div>
      </div>
    );
  }

  render() {
    return this.props.editMode ? this.showRowEdit() : this.showRow();
  }
}
